import { FormEvent, useEffect, useState } from "react";
import Button from "@material-ui/core/Button";
import Delete from "@material-ui/icons/Delete";
import Dialog from "@material-ui/core/Dialog";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Typography from "@material-ui/core/Typography";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import { usePriorityStyles } from "../../styles";
import { useGuicheDeleteStyles } from "./styles";
import { Priority } from "../../../../@types/priority";
import { usePriorityDelete } from "../../../../services/api-tansquery/priority/delete";

type Props = {
    priority: Priority;
    buttonTrigger?: React.ReactNode;
}

export default function PriorityActiveToggle({ priority, buttonTrigger }: Props) {
    const [open, setOpen] = useState(false);
    const { classes } = useGuicheDeleteStyles();
    const { classes: defaultClasses } = usePriorityStyles();
    const mutation = usePriorityDelete();

    async function handleSubmit(event: FormEvent<HTMLDivElement>) {
        event.preventDefault();

        if (mutation.isLoading) {
            return;
        }

        await mutation.mutateAsync(priority.id);
    }

    useEffect(() => {
        if (mutation.isSuccess) {
            setOpen(false);
        }
    }, [mutation.isSuccess]);

    return (
        <>
            {buttonTrigger ? (
                <span onClick={() => setOpen(true)}>
                    {buttonTrigger}
                </span>
            ) : (
                <Button
                    startIcon={<Delete />}
                    className={defaultClasses.addButton}
                    onClick={() => setOpen(true)}
                >
                    Remover Prioridade
                </Button>
            )}
            <Dialog open={open} maxWidth="sm">
                <Card component="form" onSubmit={handleSubmit}>
                    <CardHeader
                        avatar={<Delete />}
                        className={classes.cardHeader}
                        title={
                            <Typography variant="h5">
                                Remover Prioridade
                            </Typography>
                        }
                    />
                    <CardContent className={classes.cardContent}>
                        <Typography className={classes.textWarning}>
                            Você está prestes a remover a prioridade <strong>{priority?.nome}</strong> do sistema.
                        </Typography>
                        <Typography className={classes.textWarning}>
                            Tem certeza que deseja continuar?
                        </Typography>
                    </CardContent>
                    <CardActions className={classes.cardActions}>
                        <Button
                            className={classes.button}
                            onClick={() => setOpen(false)}
                            disabled={mutation.isLoading}
                        >
                            Cancelar
                        </Button>
                        <Button
                            type="submit"
                            className={classes.duplicateButton}
                            disabled={mutation.isLoading}
                        >
                            {mutation.isLoading ? "Removendo prioridade..." : "Remover Prioridade"}
                        </Button>
                    </CardActions>
                </Card>
            </Dialog>
        </>
    );
}
